import React, { useEffect, useState } from 'react';
import {Helmet} from "react-helmet";
import { useViewport } from 'hooks';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCookie } from 'hooks/useCookie';
import styled from 'styled-components';
import {getBrowserLang} from 'utils';
import Header from './header/Header';
import Footer from './footer/Footer';
import { MoHeader } from './header/MoHeader';

export function Layout(props) {
  const { t, i18n} = useTranslation();
  const { width } = useViewport();
  const location = useLocation();
  const navigate = useNavigate();
  const [delOpen, setDelOpen] = useState(false);
  const [moOpen, setMoOpen] = useState(false);
  const [background, setBackground] = useState(false);
  const { getCookie } = useCookie();
  const token = getCookie('token');



  useEffect(() => {
    const lang = getBrowserLang();
    console.info('-----------------lang-------------------');
    console.info(lang);
    i18n.changeLanguage(lang);
  }, []);

  useEffect(() => {
    const paths = ['login', 'signup', 'forgotpassword', 'changepassword', 'complete'];
    setBackground(paths.some((path) => location.pathname.includes(path)));
  }, [location]);

  return (
    <>
      <Helmet>
        <meta name="keywords" content={t('meta.keywords.common')}/>
      </Helmet>
      {width <= 1023 ? (
        <MoHeader
          delOpen={delOpen}
          setDelOpen={setDelOpen}
          background={background}
          moOpen={moOpen}
          setMoOpen={setMoOpen}
          navigate={navigate}
          location={location}
          token={token}
        />
      ) : (
        <Header
          delOpen={delOpen}
          setDelOpen={setDelOpen}
          background={background}
          navigate={navigate}
          location={location}
          token={token}
        />
      )}
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </>
  );
}

const Main = styled.main`
  padding-top: 100px;

  @media ${({ theme }) => theme.device.tablet} {
    padding-top: 60px;
  }
`;
